import { render } from "./Title3App.vue?vue&type=template&id=2297b4b3"
import script from "./Title3App.vue?vue&type=script&lang=js"
export * from "./Title3App.vue?vue&type=script&lang=js"

import "./Title3App.vue?vue&type=style&index=0&id=2297b4b3&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__